<template>
  <div
    v-click-outside="$_dropdownClose"
    class="icon-nav-drawer"
  >
    <div
      class="icon-nav-drawer_icon"
      :class="{active:dropDownMenuShow}"
      @click.stop.prevent="$_buttonOnClick()"
    >
      <i class="button-icon icon-more" />
    </div>
    <transition mode="out-in">
      <div
        v-if="dropDownMenuShow"
        class="icon-nav-drawer_dropdown-wrap"
      >
        <div
          v-for="(item_e,item_k) in navList"
          :key="item_k"
          class="icon-nav-drawer_dropdown-item"
          @click="$_navItemClick(item_e.value)"
        >
          <i
            class="item-icon"
            :class="[{red:item_e.color==='red'},item_e.icon]"
          />
          <p class="item-text">
            {{ $t(item_e.text) }}
          </p>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import ClickOutside from "vue-click-outside";
export default {
  name: "IconNavDrawer",
  directives: {
    ClickOutside,
  },
  props: {
    navList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data: () => ({
    dropDownMenuShow: false,
  }),
  methods: {
    $_dropdownClose() {
      this.dropDownMenuShow = false;
    },
    $_dropdownOpen() {
      this.dropDownMenuShow = true;
    },
    $_buttonOnClick() {
      this.dropDownMenuShow = !this.dropDownMenuShow;
    },
    $_navItemClick(e) {
      this.$emit("click", e);
      this.$_dropdownClose();
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/icon-nav-drawer";
</style>